<template>
  <table>
    <!--
        <tr>
          <td>Nummer</td>
          <td><SogDataLabel :value="props.orderHead.orderNumber" /></td>
        </tr>
    -->
    <tr>
      <td>Produkt</td>
      <td>
        <SogDataLabel :value="props.insurance.productDescription" />
      </td>
    </tr>
    <tr>
      <td>Prämie</td>
      <td>
        <SogDataLabel
          :value="props.insurance.grossPrice"
          value-type="Money"
        />
      </td>
    </tr>
    <tr>
      <td>Bestelldatum</td>
      <td>
        <SogDataLabel
          :value="props.insurance.createDate"
          :value-type="SogDataLabelValueType.DateTime"
        />
      </td>
    </tr>
    <tr v-show="_isKzkOrTz">
      <td>Evb</td>
      <td>
        <SogDataLabel :value="props.insurance.evb" />
        <SogButton
          v-show="_evbVisible"
          mdi-icon="mdi-information"
          :button-style="SogButtonStyle.Link"
          @click="onEvbClick"
        />
      </td>
    </tr>
    <tr v-show="!_isKzkOrTz">
      <td>Formularnummer</td>
      <td>
        <SogDataLabel :value="props.insurance.formNumber" />
        <SogButton
          v-show="props.insurance.insuranceExportBlankId"
          mdi-icon="mdi-file-document"
          :button-style="SogButtonStyle.Link"
          @click="onBlankClick"
        />
      </td>
    </tr>
    <tr v-show="_isKzkOrTz">
      <td>Aktivierungscode</td>
      <td>
        <SogDataLabel :value="props.insurance.activationCode" />
      </td>
    </tr>
    <tr v-show="_isKzkOrTz">
      <td>Aktivierungsdatum</td>
      <td>
        <SogDataLabel
          :value="props.insurance.activationDate"
          :value-type="SogDataLabelValueType.DateTime"
        />
      </td>
    </tr>
    <tr v-show="_isKzkOrTz">
      <td>Gültig bis</td>
      <td>
        <SogDataLabel
          :value="props.insurance.evbValidityDate"
          :value-type="SogDataLabelValueType.DateTime"
        />
      </td>
    </tr>
    <tr v-show="props.insurance.inceptionDate">
      <td>Versicherungsbeginn</td>
      <SogDataLabel
        :value="props.insurance.inceptionDate"
        :value-type="SogDataLabelValueType.DateTime"
      />
    </tr>
    <tr v-show="props.insurance.expiryDate">
      <td>Versicherungsende</td>
      <SogDataLabel
        :value="props.insurance.expiryDate"
        :value-type="SogDataLabelValueType.DateTime"
      />
    </tr>
  </table>
</template>

<script setup lang="ts">
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import Insurance from "@/shared/model/Insurance";
import {InsuranceType} from "@/shared/model/insuranceType";
import {computed} from "vue";
import SogButton from "@/shared/ui/SogButton.vue";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";
import {useNavigationStore} from "@/modules/Navigation/store";
import {IdType} from "@/shared/model/idType";

/*export default {
  name: "InsuranceHeadComponent"
}*/
interface Props {
  insurance?: Insurance;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  insurance: undefined,
});

const _navigationStore = useNavigationStore();

const _isKzkOrTz = computed(() => {
  return (
    props.insurance?.insuranceType === InsuranceType.Kzk ||
    props.insurance?.insuranceType === InsuranceType.Tz
  );
});

const _evbVisible = computed(() => {
  return props.insurance?.evb && props.insurance?.evb?.length > 0;
});

function onEvbClick() {
  if (props.insurance?.evb) {
    _navigationStore.showObject(IdType.Evb, props.insurance.evb);
  }
}

function onBlankClick() {
  if (props.insurance?.insuranceExportBlankId) {
    _navigationStore.showObject(IdType.InsuranceExportBlank, props.insurance.insuranceExportBlankId);
  }
}

</script>

<style scoped>
td {
  padding-right: 10px;
}
</style>
